module.exports = "/images/little-man.svg?1972f036be9f195f31230ca6349f8052";